import { useMemo } from 'react'
import { colors } from 'shared-ui'
import { useIntl } from 'react-intl'
import useUnit from '../../hooks/useUnit'
import { ScoreIndicator as ScoreIndicatorRenderer } from 'shared-ui'

export default function ScoreIndicator({
    value,
    decimals = 1,
    color = colors.main1,
    backgroundColor,
    bright = true,
    metricUnit,
    ...props
}) {
    const { formatUnit, formatUnitName } = useUnit()
    const { formatMessage } = useIntl()

    const convertedUnit = useMemo(() => {
        let convertedUnit = typeof value === 'number' ?
            formatUnit(value, metricUnit, {
                metricPrecision: decimals,
                hideAllUnits: true,
            })
            : undefined
        return convertedUnit
    }, [value, metricUnit, formatUnit])

    return <ScoreIndicatorRenderer
        isNull={value === null}
        color={color}
        backgroundColor={backgroundColor}
        valueString={convertedUnit}
        unitName={formatUnitName(metricUnit)}
        notApplicableAbbrString={formatMessage({ id: 'notApplicableAbbr' })}
        {...props}
    />
}